import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import ClientLedgerReport from "../../components/reports/ClientLedgerReport";
import setTitle from "../../helpers/TitleComponent";

export default class ClientLedgerReportPagePage extends Component {
  componentDidMount() {
    setTitle("Client Ledger Report");
  }
  render() {
    return (
      <div>
        <MyNavbar />
        <ClientLedgerReport />
      </div>
    );
  }
}
